export const en = {
  // Header Menu
  menu_register: 'Register',
  menu_login: 'Login',
  menu_bulletin_board: 'Marketplace',
  menu_wallet: 'Wallet',
  menu_inbox: 'Inbox',
  menu_actions: 'Actions',
  // Search Bar:
  search_bar_worth: 'Property value',
  search_bar_share_price: 'Price per Share',
  search_bar_return: 'Net rental return',
  search_bar_availability: 'Availability',
  // Asset Preview
  asset_preview_net_rental_return: 'Net rental return',
  asset_preview_total_return: 'Total return',
  asset_preview_new: 'NEW',
  asset_preview_price_per_share: 'Price per share',
  asset_preview_issued_bricks: 'Issued Bricks',
  asset_preview_finance_volume: 'Financial Goal',
  // Market
  bulletin_button_agb: 'CTC & privacy policy',
  bulletin_button_agb_close: 'Close',
  bulletin_title: 'Marketplace',
  // Asset View
  asset_view_net_rental_return: 'Expected net rental return',
  asset_view_total_return: 'Total return',
  asset_view_net_value_return: 'Expected value growth p.a.*',
  asset_view_finance_progress: 'pledged',
  asset_view_finance_remaining: 'left',
  asset_view_finance_lowest_available_price: 'Lowest available price',
  asset_view_finance_last_price: 'Last Price Traded',
  asset_view_finance_available_shares: 'Available Bricks',
  asset_view_finance_existing_shares: 'Issued Bricks',
  asset_view_finance_volume: 'Financing Goal',
  asset_view_finance_value: 'Last Market Value',
  asset_view_finance_invest: 'Invest',
  asset_view_finance_offers: 'Current offers',
  asset_view_all_informations: 'Alle Informationen zum Investment',
  asset_view_object_details: 'Objectdetails',
  asset_view_investment_overview: 'Investment overview',
  asset_view_rental_overview: 'Rental information',
  asset_view_partner: 'Partner',
  asset_view_documents: 'Documents',
  asset_view_legal_hint: 'Legal warnings',
  asset_view_legal_text: "The acquisition of this security is associated with considerable risks and can lead to the complete loss of the assets invested. The information contained in this document is directed exclusively at persons who have their residence or habitual abode in Austria or Germany. The information does not constitute an offer to purchase or subscribe for the issuer's participation certificates or an invitation to submit an offer to purchase the issuer's participation certificates. The information is for advertising purposes only. In particular, the information does not constitute financial or other investment advice. The information contained herein cannot replace investor and investment advice tailored to the individual circumstances of the investor. The issuer clearly points out that the information contained in the issuer's information sheet published on the issuer's website (www.brickwise.com/Kadaster-RE-01), where it can be downloaded free of charge, is solely relevant for the assessment of the participation certificates.",
  asset_view_location: 'Location',
  // Register View
  register_personal_information: 'Personal information',
  register_address: 'Official address',
  register_phone: 'Phonenumber',
  register_additional_information: 'Addiotional informationen',
  register_verification: 'Verification',
  register_account: 'Paymentaccount',
  register_password: 'Password',
  register_finish: 'Finish',

  InformationDialog: {
    close: 'Schließen',
    open_positions_pl: {
      heading1: 'Open positions P/L',
      text1: 'The change of your portfolio value is calculated on the basis of the las price the real estates was traded. The change is the sum of your profits and losses that you could  realise by selling all your assets. ',
      heading2: 'Return',
      text2: 'The percentage value is the return you could realise by selling all your assets.'
    },
    closed_positions_pl: {
      heading1: 'Closed positions P/L',
      text1: 'Closed positions P/L show you the sum of your realised profits and losses from the sales of your assets. Profits and losses are calculated by Brickwise according to the FIFO principle (First-In-First-Out).',
      heading2: 'Return',
      text2: 'The percentage value is the average volume-based return on your asset sales.'
    },
    last_price: {
      heading1: 'Last price',
      text1: 'The last price is the price at which a share of the real estate has been traded (bought or sold) the last time. '
    },
    last_market_value: {
      heading1: 'Last market value',
      text1: 'The last market value of your assets is calculated based on the last price and the number of your shares. '
    },
    expected_rental_return: {
      heading1: 'Expected net rental return',
      text1: 'The expected net rental return is the percentage of the recurring rental income from the real estate per year that you could receive based on your investment.'
    },
    transaction_fee: {
      heading1: 'Transaction fee',
      text1: 'The transaction fees for each executed offer are 1.5%. The fees are inclusive of the legally owed value added tax. Further details can be found in the transaction fees of Brickwise Financial Services GmbH. '
    },
    possibly_pl: {
      heading1: 'Closed position P/L',
      text1: 'Closed position P/L shows you the possible profit or loss from the sale of your shares based on your selling price. Profits and losses are calculated by Brickwise according to the FIFO principle (First-In-First-Out).',
      heading2: 'Return',
      text2: 'The percentage value is the return you could realise by selling your shares.\n'
    }
  }

}

export default en
